import { Button } from '@chakra-ui/react';
import { Compass } from 'iconoir-react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { ErrorLayout } from '@/components/ui/ErrorLayout';

const NotFoundPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <ErrorLayout
      icon={
        <Compass width={36} height={36} color="var(--chakra-colors-gray-500)" strokeWidth={1.5} />
      }
      code={t('routeError.notFound.code')}
      title={t('routeError.notFound.title')}
      description={t('routeError.notFound.description')}
      accentColor="gray"
    >
      <Button asChild colorPalette="gray" variant="solid" size="lg">
        <Link to="/dashboard">{t('routeError.notFound.action')}</Link>
      </Button>
    </ErrorLayout>
  );
};

export default NotFoundPage;
